<template>
  <q-chip
    :id="id"
    :label="label"
    :size="size"
    :outline="outline"
    :removable="removable"
    :clickable="clickable"
    @remove="remove(id)"
    :color="color"
    text-color="white"
    :dense="dense"
    :square="square"
  >
    <slot />
  </q-chip>
</template>

<script>
export default {
  name: 'Chip',
  props: {
    size: {
      type: String,
      default: 'md',
    },
    label: {
      type: String,
    },
    color: {
      type: String,
      default: 'primary',
    },
    id: {
      type: [String, Number],
    },
    outline: {
      type: Boolean,
      default: false,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    square: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    remove(id) {
      this.$emit('remove', id);
    },
  },
};
</script>

<style scoped></style>
